import Upload from './Upload';
import Dragger from './Dragger';
Upload.Dragger = Dragger;
export default Upload;


//////////////////
// WEBPACK FOOTER
// ../~/antd/es/upload/index.js
// module id = 831
// module chunks = 0